import get from 'lodash/get';

import {FEATURES} from '@constants/features';

import {featureToggle} from '@utils/featureToggle/featureToggle';

import {generateEditModeReportOptions} from '../containers/Preferences/_shared/utils.report-form';
import {NOTIFICATION_TYPES} from '../redux/modules/preferences/utils';
import {processForApi} from '../redux/modules/preferences/utils.report-form';
import {formatLocations} from './preferences';

function transformTripBookingToService(preferences) {
  const report = get(preferences, ['report']);

  const destinationTypes = get(preferences, ['destinationTypes']);
  const alwaysSendForHotelOnlyTrips = get(preferences, ['alwaysSendForHotelOnlyTrips']);

  return {
    name: preferences.name,
    type: NOTIFICATION_TYPES.TRIP_BOOKINGS,
    config: {
      locationIds: preferences.locations?.map((location) => location.value),
      ...(featureToggle(FEATURES.PDM_100)
        ? {customPersonTypeIds: preferences.customPersonTypeIds}
        : {personTypes: preferences.personTypes}),
      minimumCountryRiskRating: preferences.minimumCountryRiskRating,
      notifyWhenTripIsUpdated: preferences.notifyWhenTripIsUpdated,
      notifyWhenTripIsCancelled: preferences.notifyWhenTripIsCancelled,
      report: preferences.includeReport ? processForApi(report) : undefined,
      destinationTypes: {alwaysSendForHotelOnlyTrips, ...destinationTypes},
    },
  };
}

function transformConfig(config = {}, locationsDict) {
  const {locationIds, report, destinationTypes = {}, ...rest} = config;

  const {alwaysSendForHotelOnlyTrips, ...otherTypes} = destinationTypes;

  const hasDestinationType = Object.keys(otherTypes).reduce(
    (accumulator, key) => accumulator || otherTypes[key],
    false,
  );

  return {
    ...rest,
    locations: formatLocations(locationIds, locationsDict),
    report: generateEditModeReportOptions(report),
    includeReport: !!report,
    alwaysSendForHotelOnlyTrips,
    ...(hasDestinationType ? {destinationTypes: otherTypes} : {}),
  };
}

function transformFromServiceToTripBooking(preference, locationsDict) {
  const {config, id, name, valid} = preference || {};

  return {
    ...transformConfig(config, locationsDict),
    id,
    name,
    valid,
  };
}

export {transformFromServiceToTripBooking, transformTripBookingToService};
